// eslint-disable-next-line import/order
import type { ComponentType } from 'react';

import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import Flag from './main';

const FlagWithEvents: ComponentType<any> = withEvents(Flag);

export { Flag, FlagWithEvents };

// eslint-disable-next-line camelcase
const _default_1: ComponentType<any> = withMessage(FlagWithEvents, 'flag');
// eslint-disable-next-line camelcase
export default _default_1;
